import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = /^https:\/\/viewer\.diagrams\.net\/.*(title=\w+)?/;
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const { newUrl, title } = React.useMemo(() => {
    const urlObj = new URL(url);
    const documentTitle = urlObj.searchParams.get('title');
    const newTitle = documentTitle
      ? `Diagrams.net (${documentTitle})`
      : 'Diagrams.net';

    return { newUrl: url, title: newTitle };
  }, [url]);

  return (
    <Portal {...rest} url={newUrl} title={title} fullHeight withMetadata />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'diagrams-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Diagrams',
    description: 'Embed a Diagrams.net diagram.',
    searchTerms: ['embed', 'diagrams'],
    icon: 'simple-icons:diagramsdotnet',
  },
});
